import React, { useState } from 'react';
import { A } from 'hookrouter';
import { useForm } from 'hooks';
import { checkRequiredFields, ErrorChecklist } from 'common';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import InputGroup from 'react-bootstrap/InputGroup';
import showIcon from 'images/show.png';
import hideIcon from 'images/hide.png';
import './memberSignUpForm.scss';

const MemberSignUpForm = ({ signUp }) => {
  const requiredFields = ['login', 'password', 'reenter'];
  const [maskPassword, setMaskPassword] = useState(true);
  const [maskPasswordReenter, setMaskPasswordReenter] = useState(true);

  const signUpFormValidationRules = (values) => {
    let errors = {};

    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        values.login
      )
    ) {
      errors.login = 'Invalid email address';
    }

    if (
      !/^.{8,30}$/.test(values.password) ||
      !/[A-Z]+/.test(values.password) ||
      !/[a-z]+/.test(values.password) ||
      !/\d+/.test(values.password) ||
      values.password.match(new RegExp(values.login, 'i'))
    ) {
      errors.password = 'Invalid password';
    }
    if (values.password !== values.reenter) {
      errors.reenter = 'Passwords do not match';
    }
    return errors;
  };

  const passwordValidationRules = [
    ['8-30 characters', (values) => /^.{8,30}$/.test(values.password)],
    ['at least one upper case character', (values) => /[A-Z]+/.test(values.password)],
    ['at least one lower case character', (values) => /[a-z]+/.test(values.password)],
    ['at least one number', (values) => /\d+/.test(values.password)],
    [
      'cannot have login in password',
      (values) => values.login && !values.password.match(new RegExp(values.login, 'i')),
    ],
  ];

  const defaultValues = { login: '', password: '', reenter: '' };
  const { values, handleChange, handleBlur, errors } = useForm(defaultValues, signUpFormValidationRules);

  return (
    <div className="occu-form occu-form-wide">
      <h4>CREATE APPLICATION LOGIN</h4>
      <Form
        name="signupForm"
        id="signupForm"
        onSubmit={(event) => {
          signUp(values.login, values.password, values.reenter);
          event.preventDefault();
        }}
      >
        <Form.Group controlId="formLogin">
          <Form.Label>Login Email Address</Form.Label>
          <Form.Control
            type="text"
            name="login"
            value={values.login}
            onBlur={handleBlur}
            onChange={handleChange}
            isInvalid={errors.login}
            autoComplete="off"
            maxLength="40"
            required
          />
          <Form.Control.Feedback type="invalid">{errors.login}</Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="formPassword">
          <Form.Label>Password</Form.Label>
          <InputGroup>
            <Form.Control
              name="password"
              type={maskPassword ? 'password' : 'text'}
              value={values.password}
              onBlur={handleBlur}
              onChange={handleChange}
              isInvalid={errors.password}
              autoComplete="off"
              maxLength="30"
              required
            />
            <InputGroup.Append>
              <Button
                variant="light"
                onClick={() => {
                  setMaskPassword(!maskPassword);
                }}
              >
                <div style={{ height: 20, width: 20 }}>
                  {maskPassword ? <Image src={showIcon} fluid /> : <Image src={hideIcon} fluid />}
                </div>
              </Button>
            </InputGroup.Append>
          </InputGroup>
          <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="formPasswordReenter">
          <Form.Label>Re-enter Password</Form.Label>
          <InputGroup>
            <Form.Control
              value={values.reenter}
              type={maskPasswordReenter ? 'password' : 'text'}
              name="reenter"
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={errors.reenter}
              autoComplete="off"
              maxLength="30"
              required
            />
            <InputGroup.Append>
              <Button
                variant="light"
                tabIndex="-1"
                onClick={() => {
                  setMaskPasswordReenter(!maskPasswordReenter);
                }}
              >
                <div style={{ height: 20, width: 20 }}>
                  {maskPasswordReenter ? <Image src={showIcon} fluid /> : <Image src={hideIcon} fluid />}
                </div>
              </Button>
            </InputGroup.Append>
            <Form.Control.Feedback type="invalid">{errors.reenter}</Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
        <Form.Group>
          <ErrorChecklist rules={passwordValidationRules} {...values} />
        </Form.Group>
        <Form.Text>
          By selecting the Submit button, you agree to receive a call(s), text(s), or email(s) regarding an Orange
          County's Credit Union home loan. Data rates may apply.
        </Form.Text>
        <br />
        <br />
        <Form.Group controlId="formSubmit">
          <Button
            variant="occu-primary"
            type="submit"
            block
            disabled={
              !checkRequiredFields(requiredFields, values) ||
              (Object.entries(values).length === 0 && values.constructor === Object) ||
              (Object.entries(errors).length > 0 && errors.constructor === Object)
            }
          >
            Submit
          </Button>
        </Form.Group>
      </Form>
      <h5>
        Already enrolled? <br />
        Click <A href="/mortgage/sign-in">here</A>
      </h5>
    </div>
  );
};

export default MemberSignUpForm;
